let timerId;
const debounce = (fn, delay) => {
  clearTimeout(timerId);
  timerId = setTimeout(() => fn(), delay);
};

export { debounce };
